<template>
  <div>
    <files-manager
      v-model="files"
      :signDeleted="true"
      label="Adaugă documente"
      :convertToPdf="true"
      :allowExtensions="['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png']"
      @converting="onConverting"
    >
    </files-manager>
    <div class="">
      <b>Documente încarcate</b>

      <div style="position: relative">
        <transition-group name="popup">
          <h4
            key="0"
            v-if="documentsList.length == 0"
            class="prettyH4"
            style="color: #888; position: absolute; top: 0; left: 0; right: 0"
          >
            <i class="fas fa-times"></i>
            Nu sunt documente
          </h4>
          <div
            key="1"
            v-else
            class="TBParent referenceStatusesBeautify"
            style="max-height: 60rem !important"
          >
            <table>
              <thead>
                <th style="width: 4rem">Nr.</th>
                <th>Denumire</th>
                <th style="display: flex; justify-content: flex-end">
                  Acțiuni
                </th>
              </thead>
              <tbody>
                <tr v-for="(doc, index) in documentsList" :key="index">
                  <td>{{ index + 1 }}.</td>
                  <td>{{ doc.name }}</td>
                  <td
                    style="
                      display: flex;
                      justify-content: flex-end;
                      cursor: pointer;
                    "
                  >
                    <div
                      style="display: flex; align-items: center"
                      @click="viewPdf(doc)"
                    >
                      <i
                        v-tooltip="{ content: 'Deschide fișier' }"
                        style="color: #337ab7"
                        class="fas fa-external-link-alt"
                      ></i>
                    </div>
                    <div
                      v-if="assignmentDocument.status == 'approved'"
                      style="margin: 0px 10px"
                    >
                      |
                    </div>
                    <div
                      v-if="assignmentDocument.status == 'approved'"
                      style="
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                      "
                      @click="deleteDoc(doc)"
                    >
                      <i
                        v-tooltip="{ content: 'Șterge fișier' }"
                        style="color: #ec4a4a"
                        class="fas fa-trash"
                      ></i>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import FilesAgent from "@/components/FilesAgent";
import { mapMutations } from "vuex";
import { ASSIGNMENT_DOCUMENTS } from "@/api.js";
import DialogModal from "@/components/DialogModal";

export default {
  components: {
    "files-manager": FilesAgent,
  },
  props: {
    assignmentDocument: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      files: [],
      localAssignmentDocument: this.assignmentDocument,
      filesConverting: false,
    };
  },
  watch: {
    files: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    documentsList() {
      return this.localAssignmentDocument.documents || [];
    },
  },
  methods: {
    ...mapMutations(["setReferenceIdForPreview", "addWindow"]),
    onConverting(val) {
      this.filesConverting = val;
      this.$emit("converting", val);
    },
    viewPdf(doc) {
      this.addWindow(
        Object.assign({
          fileList: [doc.key],
          fileNames: { [doc.key]: doc.name },
          itemId: this.localAssignmentDocument.id,
          canDelete: false,
          modal: 13,
          select: 0,
          searchModuleApi: ASSIGNMENT_DOCUMENTS.getDocument,
        })
      );
    },
    deleteDoc(doc) {
      this.$modal.show(
        DialogModal,
        {
          target: "DeleteAssignmentDocumentDocument",
          title: "Șterge Document",
          inputs: [],
          closeBtnText: "Anulează",
          button: {
            type: 3,
            value: "Șterge",
            handler: () => {
              const error = (msg) => {
                this.$toastr.e(msg || "Documentul nu a fost șters.");
                this.setLoad();
              };

              this.setLoad(true);
              ASSIGNMENT_DOCUMENTS.deleteDocument(
                this.localAssignmentDocument.id,
                {
                  key: doc.key,
                }
              )
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Documentul a fost șters.");
                    this.localAssignmentDocument.documents =
                      this.localAssignmentDocument.documents.filter(
                        (el) => el.key !== doc.key
                      );
                    this.setLoad();
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "DeleteAssignmentDocumentDocument",
          adaptive: true,
          width: "550",
          height: "300",
        }
      );
    },
  },
  created() {
    this.$emit("input", this.files);
  },
};
</script>

<style></style>
